import { render } from "./BalLoadingBlock.vue?vue&type=template&id=719ac7b1&ts=true"
import script from "./BalLoadingBlock.vue?vue&type=script&lang=ts"
export * from "./BalLoadingBlock.vue?vue&type=script&lang=ts"

import "./BalLoadingBlock.vue?vue&type=style&index=0&id=719ac7b1&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__